export default "__VITE_ASSET__DmH2BZoL__"